import React from 'react';
import styles from '../Operations.module.css';

interface SARDComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const SARD: SARDComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
       Metric Description
      </div>
      <div className={styles.sectionContent}>
        Helpful is our foundation – we exist to help other and it&apos;s at the root of everything we do. We must continue to elevate the level of service we provide and keep our customers coming back. This can be achieved through putting our customer first and ensuring associates have the resources, knowledge and ability to deliver on our Helpful Promise with every customer, every time. It&apos;s a no-brainer. Helping customers increases your bottom line!
        <br /><br />
      </div>

      <div className={styles.sectionTitle}>
       Supporting Details
      </div>
      <div className={styles.sectionContent}>
          <strong>What makes up an Assistance Received Score:</strong>
          <br /> 
        Assistance Received is the sum of Basic and Advanced Help divided by the total number of surveys.
      </div>

      <div className={styles.sectionTitle}>
      Example
      </div>
      <div className={styles.sectionContent}>
          Ace surveyed 321,507 customers, with 73.9% of those surveyed indicating that they received either Basic Help or Advanced Help.
      </div>
      

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        Within the Rolling 12 months, 120 or more Customer Engagement Surveys with an Assistance Received score of = <strong>80% or higher</strong>
        <br />
      </div>

       <div className={styles.sectionTitle}>
        Drill Down
      </div>

      <div className={styles.sectionContent}>
        To drill down into your Assistance Received data login to the:{' '}
        <a
          href="https://acehardware.medallia.com/sso/acehardware/idpSelect.do"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Helpful Experience/Medallia Dashboard
        </a>{' '}
        and view the CE Overview page.
        <br /><br /> 
        You can also use the Dashboard to take a deeper dive into your Survey, Mystery Shop Data, Customer Journey, BOPIS and Curbside data.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        For help with assistance received go to{' '}
        <a
          href="https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          ACENET &gt; AWOR &gt; Helpful Experience &gt; Customer First Sales Culture
        </a>
      </div>


    </div>
  );
};

SARD.title = 'Assistance Received';
SARD.actionTitle = 'Review Medallia Dashboard';
SARD.actionHyperlink = 'https://acehardware.medallia.com/sso/acehardware';
export default SARD;

